import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import { ProductListInterfaceForWriteOffPage } from "../../../../../interfaces/interfaces";
import { checkForEmptyValue } from "@me-team/host/src/utils/utils";
import { TooltipCustom } from "@services/ui-components";

type ProductListTableProps = {
    productList: ProductListInterfaceForWriteOffPage[];
    addProductToWriteOff: (product: ProductListInterfaceForWriteOffPage) => void;
};

const ProductListTable: React.FC<ProductListTableProps> = (props) => {
    const { t: translate } = useTranslation();

    if (!props.productList.length) {
        return (
            <Row>
                <Col xl={5} className="mx-auto text-center mb-5">
                    <h5 className="fw-bold">
                        {translate("No products were found for the specified values in the filters or search.")}
                    </h5>
                </Col>
            </Row>
        );
    }

    return (
        <Table responsive className="align-middle">
            <thead className="fs-7">
                <tr>
                    <th className="col-2 ps-4">{translate("Product name")}</th>
                    <th className="col-2">{translate("Brand")}</th>
                    <th className="col-2">{translate("Category")}</th>
                    <th className="col-1"></th>
                    <th className="col-1">{translate("ProductsList.SKU")}</th>
                    <th className="col-2">{translate("ProductsList.Barcode")}</th>
                    <th className="col-1">{translate("ProductsList.Unit")}</th>
                    <th className="col-1"></th>
                </tr>
            </thead>
            <tbody>
                {props.productList.map((product: ProductListInterfaceForWriteOffPage) => {
                    return (
                        <tr key={product.id}>
                            <td className="col-2 ps-4">{product.name}</td>
                            <td className="col-2">{product.brand}</td>
                            <td className="col-2">{product.categoryName}</td>
                            <td className="col-1"></td>
                            <td className="col-1">{checkForEmptyValue(product.sku)}</td>
                            <td className="col-2">{checkForEmptyValue(product.barcode)}</td>
                            <td className="col-2">{product.unit.name}</td>
                            <td className="col-1 text-end pe-0">
                                {!product.isHidden && (
                                    <TooltipCustom placement="bottom" text={translate("Add Product")}>
                                        <Button
                                            className={"btn rounded border text-dark bg-white rounded-1"}
                                            onClick={() => props.addProductToWriteOff(product)}
                                        >
                                            <i className="bi bi-plus-lg d-flex fs-normal"></i>
                                        </Button>
                                    </TooltipCustom>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default React.memo(ProductListTable);
